import {
  SESSION_INVALIDATING,
  SESSION_SAFE_UPDATE,
  TRAINING_CARDS_UPDATED_EVENT,
  TRAINING_CARDS_REMOVED_EVENT,
  IMPLICIT_UPDATE_AUDIT_FIELDS,
  applyPagedMutationOverlay,
  classifyTrainingCardListMutation,
  isTableCompleteTrainingCardEmployeeRow,
  trainingCardEmployeeRowFromResponse,
} from './trainingCardListSync';

/**
 * trng011 (TrainingRecordList) list sync.
 *
 * TRNG011_ROW_ENTITY=Employee (same paged rows as trng002).
 * Nested TrainingCard / TrainingRecord content lives under employee.training_card.
 *
 * Audit scope (Employee, not TrainingRecord):
 *   TRNG011_CREATED_AUDIT_SCOPE = employees.created_at + created_by_user
 *   TRNG011_UPDATED_AUDIT_SCOPE = employees.updated_at + last_touched_by_user
 *
 * Canonical table-complete row: GET /api/training_cards/by_employee/{id}
 */

export const TRAINING_RECORD_LIST_UPDATED_EVENT = 'training_record_list:updated';
export const TRAINING_RECORD_LIST_REMOVED_EVENT = 'training_record_list:removed';

export const TRNG011_ROW_ENTITY = 'Employee';
export const TRNG011_CREATED_AUDIT_SCOPE = 'employees.created_at+created_by_user';
export const TRNG011_UPDATED_AUDIT_SCOPE = 'employees.updated_at+last_touched_by_user';
export const SAFE_CANONICAL_ROW_ENDPOINT = '/api/training_cards/by_employee/{id}';

export {
  SESSION_SAFE_UPDATE,
  SESSION_INVALIDATING,
  TRAINING_CARDS_UPDATED_EVENT,
  TRAINING_CARDS_REMOVED_EVENT,
  IMPLICIT_UPDATE_AUDIT_FIELDS,
  applyPagedMutationOverlay,
  classifyTrainingCardListMutation,
  isTableCompleteTrainingCardEmployeeRow,
  trainingCardEmployeeRowFromResponse,
};

/**
 * Training record writes (create/update/delete) can change my_state / membership;
 * always invalidate the progressive list session.
 */
export function classifyTrainingRecordListMutation(event, session = {}) {
  if (event?.detail?.source === 'training_record') return SESSION_INVALIDATING;
  return classifyTrainingCardListMutation(event, session);
}

export function emitTrainingRecordListMutation(detail) {
  window.dispatchEvent(new CustomEvent(TRAINING_RECORD_LIST_UPDATED_EVENT, {
    detail: detail && typeof detail === 'object' ? detail : { operation: 'invalidate', source: 'training_record' },
  }));
}

/** Prefer INVALIDATING_WRITE for training_records create/update/delete. */
export function emitTrainingRecordListInvalidatingWrite(detail = {}) {
  emitTrainingRecordListMutation({
    operation: detail.operation || 'update',
    id: detail.id ?? null,
    row: detail.row ?? null,
    changedFields: Array.isArray(detail.changedFields) ? detail.changedFields : [],
    source: 'training_record',
  });
}

export function emitTrainingRecordListRemoved(id) {
  if (id == null || id === '') return;
  window.dispatchEvent(new CustomEvent(TRAINING_RECORD_LIST_REMOVED_EVENT, { detail: { id } }));
}
